const shopGroupHomepage = {
  displayField: 'title',
  name: 'Shop Group Homepage',
  description: 'Shop Group Homepage',
  fields: [
    {
      id: 'title',
      name: 'Title',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'slug',
      name: 'Slug',
      type: 'Symbol',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'listOfficeMlsIDs',
      name: 'List Office MLS IDs',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: { type: 'Symbol', validations: [] }
    },
    {
      id: 'seo',
      name: 'SEO',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'seoPage' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'heroHeader',
      name: 'Hero Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'searchHeroCarousel',
      name: 'SearchHeroCarousel',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'heroCarousel' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'newestListingsHeader',
      name: 'Newest Listings Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'advisorPromoHeader',
      name: 'Advisor Promo Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'advisorPromoBody',
      name: 'Advisor Promo Body',
      type: 'RichText',
      localized: true,
      required: false,
      validations: [
        {
          enabledMarks: [ 'bold', 'italic' ],
          message: 'Only bold and italic marks are allowed'
        },
        { enabledNodeTypes: [], message: 'Nodes are not allowed' },
        { nodes: {} }
      ],
      disabled: false,
      omitted: false
    },
    {
      id: 'advisorPromoAdvisorId',
      name: 'Advisor Promo AdvisorId',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: { type: 'Symbol', validations: [] }
    },
    {
      id: 'advisorsCustom',
      name: 'Custom Advisors',
      type: 'Array',
      localized: false,
      required: false,
      validations: [ { size: { min: null, max: 3 } } ],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'advisorCustom' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'neighborhoodsHeader',
      name: 'Neighborhoods Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'featuredNeighborhoods',
      name: 'Featured Neighborhoods',
      type: 'Array',
      localized: false,
      required: false,
      validations: [ { size: { min: 1, max: 5 } } ],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [ { linkContentType: [ 'neighborhoodSingle' ] } ],
        linkType: 'Entry'
      }
    },
    {
      id: 'ourLocalShopsHeadline',
      name: 'Our Local Shops Headline',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'localShopIds',
      name: 'Local Shop Ids',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: { type: 'Symbol', validations: [] }
    },
    {
      id: 'aboutContent',
      name: 'About Content',
      type: 'Link',
      localized: false,
      required: false,
      validations: [
        {
          linkContentType: [ 'wideTextImage', 'WideStackedTextImageBlock' ]
        }
      ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'bigPictureCta',
      name: 'Big Picture CTA',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'bigPictureCta' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'storyContentNested',
      name: 'Story Content Nested',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'nestedTextImageBlock' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'statisticGroup',
      name: 'StatisticGroup',
      type: 'Link',
      localized: false,
      required: false,
      validations: [ { linkContentType: [ 'statisticGroup' ] } ],
      disabled: false,
      omitted: false,
      linkType: 'Entry'
    },
    {
      id: 'blogHeader',
      name: 'Blog Header',
      type: 'Symbol',
      localized: true,
      required: false,
      validations: [],
      disabled: false,
      omitted: false
    },
    {
      id: 'dynamicContentBlocks',
      name: 'Dynamic Content Blocks',
      type: 'Array',
      localized: false,
      required: false,
      validations: [],
      disabled: false,
      omitted: false,
      items: {
        type: 'Link',
        validations: [
          {
            linkContentType: [
              'WideStackedTextImageBlock',
              'wideTextImage',
              'StackedTextImageForm'
            ]
          }
        ],
        linkType: 'Entry'
      }
    }
  ],
  metadata: {
    annotations: {
      ContentType: [
        {
          sys: {
            id: 'Contentful:AggregateRoot',
            type: 'Link',
            linkType: 'Annotation'
          }
        }
      ],
      ContentTypeField: {
        featuredNeighborhoods: [
          {
            sys: {
              id: 'Contentful:AggregateComponent',
              type: 'Link',
              linkType: 'Annotation'
            }
          }
        ],
        searchHeroCarousel: [
          {
            sys: {
              id: 'Contentful:AggregateComponent',
              type: 'Link',
              linkType: 'Annotation'
            }
          }
        ],
        statisticGroup: [
          {
            sys: {
              id: 'Contentful:AggregateComponent',
              type: 'Link',
              linkType: 'Annotation'
            }
          }
        ]
      }
    }
  },
  sys: {
    id: 'shopGroupHomepage',
    version: 80,
    updatedAt: '2023-08-03T14:30:13.657Z'
  }
};
export default shopGroupHomepage;